import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('stripeSubscriptionSummary');

    return {
        MANAGE_SUBSCRIPTION: t('manageSubscription'),
        UPGRADE_SUBSCRIPTION: t('upgradeSubscription')
    };
};

export default useTranslation;
